module.exports = __webpack_public_path__ + "img/dark-mud-decal-06.cde7e911.png";